<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />

    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>

<script>
import noticesApi from '../../../api/tender/noticesApi';

export default {
  data() {
    return {
      pageSize: 15,
      currentPage: 1,
      isLoadingGrid: false,
      breadCrumbs: [
        { title: 'صفحه اصلی', link: '/' },
        { title: 'مناقصه/مزایده‌های پایان‌یافته', link: '/admin/closed-notices', active: true },
      ],
    };
  },

  computed: {
    gridColumns() {
      return [
        { field: 'title', title: 'عنوان', template: ({ title }) => title || ' - ' },
        { field: 'notice_type', title: 'نوع', template: ({ notice_type }) => notice_type === 'tender' ? 'مناقصه' : 'مزایده' },
        { field: 'ends_at', title: 'پایان', template: ({ ends_at }) => ends_at ? this.$getJalaliDate(ends_at) : ' - ' },
        { title: 'قیمت‌ها', command: this.gridCommands() },
      ];
    },
  },

  methods: {
    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;

      noticesApi.get({
        page_size: e.data.pageSize,
        page: e.data.page,
        status: 'closed',
      })
      .then(({ data }) => e.success(data))
      .catch(() => e.success([]))
      .finally(() => {
        this.isLoadingGrid = false;
      });
    },

    viewBids(e) {
      const row = this.$refs.grid.getSelectedGridRow(e);
      this.$router.push(`/admin/notices/${row.id}/bids`);
    },

    gridCommands() {
      return [
        {
          text: 'bids',
          click: this.viewBids,
          template: '<button class="btn btn-sm btn-info">مشاهده قیمت‌ها</button>',
        },
      ];
    },
  },
};
</script>